import { Model } from '@vuex-orm/core'

export default class Quest extends Model {
    static entity = 'quests'

    static fields() {
        return {
            id: this.attr(null),
            area_id: this.attr(null),
            name: this.attr(''),
            completed: this.attr(false),
            level: this.attr(null)
        }
    }
}